import { render } from "./DriveMediaViewHeader.vue?vue&type=template&id=1bc0a161&scoped=true&ts=true"
import script from "./DriveMediaViewHeader.vue?vue&type=script&lang=ts"
export * from "./DriveMediaViewHeader.vue?vue&type=script&lang=ts"

import "./DriveMediaViewHeader.vue?vue&type=style&index=0&id=1bc0a161&lang=sass&scoped=true"

import exportComponent from "/home/casedrive/releases/front/108/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1bc0a161"]])

export default __exports__